import { Link } from "react-router-dom";

const logo = "/images/logo.png";

export default function Logo() {
    return <Link to={"/"}>
        <img src={logo} alt="Logo" width={200} height={200} className="w-30 h-30" />
        </Link>;
}
